<div class="visualcolumns">
    <ui-visual class="RELATIVE" *ngFor="let visual of uiDbService.visuals; let i=index"
        [visualData] = 'visual'
        [visualIndex] = 'i'
        (click)="uiDbService.setActiveColumn(i)"
    ></ui-visual>
</div>
